import {isObject} from 'lodash-es';

import {ITopicCommentDto, IRequestInfo} from './request-slice-type';

/**
 * Проверяет, является ли переданный объект экземпляром `TopicCommentDto` или `RequestInfo`,
 * содержащим свойство `idRequestComment`.
 *
 * @param {unknown} obj  - Объект произвольного типа, который требуется проверить.
 * @returns {boolean} Возвращает `true`, если `obj` является объектом и содержит свойство `idRequestComment`,
 *  иначе false.
 */
export function isItemHasIdRequestComment(obj: unknown): obj is ITopicCommentDto | IRequestInfo {
    return isObject(obj) && Object.keys(obj).includes('idRequestComment');
}
